// Each gallery owns its carousel, navigation and breakpoint listener.
window.createProductGallery = function(root, { carouselOnDesktop = false, onChange = () => {} } = {}) {
  if (!root) return null;
  const viewport = root.querySelector('.product_gallery__viewport');
  const thumbs = root.querySelector('.product_gallery__thumbs');
  if (!viewport || !thumbs) return null;

  const mobileQuery = window.matchMedia('(max-width: 719px)');
  const buttons = [...thumbs.querySelectorAll('[data-slide]')];
  let carousel;
  let thumbnailCarousel;

  function updateNavigation() {
    const selectedIndex = carousel.selectedScrollSnap();
    buttons.forEach((button, index) => {
      const selected = index === selectedIndex;
      button.classList.toggle('selected-thumb', selected);
      button.setAttribute('aria-current', String(selected));
    });
  }

  function stop() {
    carousel?.destroy();
    thumbnailCarousel?.destroy();
    carousel = null;
    thumbnailCarousel = null;
    onChange(null);
  }

  function refresh() {
    if (!carouselOnDesktop && !mobileQuery.matches) {
      stop();
      return;
    }
    if (carousel || typeof EmblaCarousel === 'undefined') return;
    carousel = EmblaCarousel(viewport, { loop: false, inViewThreshold: 0 }, [EmblaCarouselAutoHeight()]);
    thumbnailCarousel = EmblaCarousel(thumbs, { loop: false, align: 'start', skipSnaps: true });
    carousel.on('select', updateNavigation);
    carousel.on('reInit', updateNavigation);
    updateNavigation();
    onChange(carousel);
  }

  function selectImage(event) {
    const button = event.target.closest('[data-slide]');
    if (button && thumbs.contains(button)) carousel?.scrollTo(Number(button.dataset.slide));
  }

  thumbs.addEventListener('click', selectImage);
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', refresh);
  else mobileQuery.addListener(refresh);
  refresh();

  return {
    get api() { return carousel; },
    destroy() {
      stop();
      thumbs.removeEventListener('click', selectImage);
      if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', refresh);
      else mobileQuery.removeListener(refresh);
    }
  };
};
